import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ReasonCodeType,
  useAddReasonCodeMutation,
} from "../../../graphql/generated";
import { testIds } from "./ReasonCodeModal.testIds";

interface ReasonCodeModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  shipmentId: string;
  tripId?: string;
  locationId?: string;
  type: ReasonCodeType;
}

const ReasonCodeModal = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  shipmentId,
  tripId,
  locationId,
  type,
}: ReasonCodeModalProps) => {
  const { t } = useTranslation(["common"]);
  const [reason, setReason] = useState("");
  const addReasonCode = useAddReasonCodeMutation();

  const handleSubmit = async () => {
    try {
      await addReasonCode.mutateAsync({
        newReasonCodeData: {
          shipmentId,
          tripId,
          locationId,
          type,
          description: reason,
        },
      });
      onConfirm();
      onClose();
    } catch (error) {
      console.error("Error creating reason code:", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 2 }}>
          <TextField
            label={t("common:reason", "Reason")}
            multiline
            rows={4}
            value={reason}
            inputProps={{ "data-testid": testIds.reasonCodeModalReason } as React.InputHTMLAttributes<HTMLInputElement>}
            onChange={(e) => setReason(e.target.value)}
            fullWidth
            required
            helperText={description}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button data-testid={testIds.reasonCodeModalCancel} onClick={onClose}>{t("common:cancel", "Cancel")}</Button>
        <LoadingButton data-testid={testIds.reasonCodeModalSave}
          variant="contained"
          onClick={handleSubmit}
          loading={addReasonCode.isLoading}
          disabled={!reason.trim()}
        >
          {t("common:save", "Save")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ReasonCodeModal;
